export enum LoginModalStep {
  LOGIN = "login",
  SIGNUP = "signup",
  EMAIL_CONFIRM = "emailConfirm",
  CODE_CONFIRM = "codeConfirm",
  FORGOT = "forgot",
  BACK_FROM_CONFIRM = "backFromConfirm",
}
